import { Box, Icon, IconButton, useColorMode } from "@chakra-ui/react";

const Sun = () => (
  <Icon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2" />
    <path d="M12 20v2" />
    <path d="m4.93 4.93 1.41 1.41" />
    <path d="m17.66 17.66 1.41 1.41" />
    <path d="M2 12h2" />
    <path d="M20 12h2" />
    <path d="m6.34 17.66-1.41 1.41" />
    <path d="m19.07 4.93-1.41 1.41" />
  </Icon>
);

const Moon = () => (
  <Icon
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401" />
  </Icon>
);

export const ColorModeButton = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  return (
    <Box
      height="0"
      width="fit-content"
      position="sticky"
      left="100%"
      top="0"
      opacity={0.3}
      transition="0.3s opacity"
      _hover={{ opacity: 1 }}
    >
      <IconButton
        aria-label={colorMode === "light" ? "Light mode" : "Dark mode"}
        colorScheme="gray"
        variant="ghost"
        icon={colorMode === "light" ? <Sun /> : <Moon />}
        onClick={() => toggleColorMode()}
      />
    </Box>
  );
};
